/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvoiceComplexity {
    SINGLE_PO = 'single_po',
    MULTI_PO = 'multi_po',
    NON_PO = 'non_po',
}
